import icon from '@assets/img/icons/principal-info.svg';
import { strings as membershipFormStrings } from '@data/membershipForm';
import { createStrings } from '@utils/local';
import { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: membershipFormStrings.principalInfo,
  },
});

export const meta: PageMeta = {
  title: strings.title,
  icon,
  order: 2,
};
